export * from './card';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/card/index.js
// module id = ../../../material/card/index.js
// module chunks = 3